/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */
// This is a plain CRA client bundle with no server/proxy of its own, so every
// fetch needs an absolute URL to the backend instead of a relative '/api/...'
// path. Baked in at build time, same as any REACT_APP_* var (CRA only
// inlines env vars with that prefix).
export const API_ORIGIN = process.env.REACT_APP_API_ORIGIN || 'https://api.udyamconnect.com';
